
import { useStore } from "vuex";
import { Actions } from "../../../store/enums/StoreEnums";
import { defineComponent, onMounted, ref, computed, Ref } from "vue";
import { ErrorMessage, Field, Form } from "vee-validate";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import * as Yup from "yup";
import DeactivateAccountModal from "@/views/crafted/modals/forms/DeactivateAccountModal.vue";

interface ProfileDetails {
  firstName: string;
  lastName: string;
  telephone: string;
  introduction: string;
  jobTitle: string;
  linkedInProfileUrl: string;
  profileImage: string;
}

export default defineComponent({
  name: "account-settings",
  components: {
    ErrorMessage,
    Field,
    Form,
    DeactivateAccountModal,
  },
  setup() {
    const loading = ref<boolean>(false);
    const loading2 = ref<boolean>(false);
    const tempImage = ref<string>("");
    const newImageAdded = ref<boolean>(false);
    const store = useStore();
    const user = computed(() => {
      return store.getters.getUser;
    });
    let file: File;
    const oldPasswordRef: Ref = ref(null);
    const newPasswordRef: Ref = ref(null);
    const passwordConfirmationRef: Ref = ref(null);
    const profilePictureRef: Ref = ref(null);
    const submitButton1 = ref<HTMLElement | null>(null);
    const submitButton2 = ref<HTMLElement | null>(null);
    const submitButton3 = ref<HTMLElement | null>(null);
    const submitButton4 = ref<HTMLElement | null>(null);
    const submitButton5 = ref<HTMLElement | null>(null);
    const updateEmailButton = ref<HTMLElement | null>(null);
    const updatePasswordButton = ref<HTMLElement | null>(null);

    const emailFormDisplay = ref(false);
    const passwordFormDisplay = ref(false);

    const profileDetailsValidator = Yup.object().shape({
      firstName: Yup.string().required().label("First name"),
      lastName: Yup.string().required().label("Last name"),
      telephone: Yup.string().required().label("Contact phone"),
    });

    const changeEmail = Yup.object().shape({
      emailaddress: Yup.string().required().email().label("Email"),
      confirmemailpassword: Yup.string().required().label("Password"),
    });

    const changePassword = Yup.object().shape({
      oldPassword: Yup.string().required().label("Old password"),
      password: Yup.string().min(8).required().label("Password"),
      password_confirmation: Yup.string()
        .min(8)
        .required()
        .oneOf([Yup.ref("password"), null], "Passwords must match")
        .label("Password Confirmation"),
    });
    const limitInput = (event) => {
      if (event.target.value.length > 11) event.preventDefault();
      if (event.charCode < 48 || event.charCode > 57) {
        event.preventDefault();
      }
    };
const formatTelephone = (e) => {
      if (e.target.value.charCodeAt(0) != 48 && e.target.value) {
        profileDetails.value.telephone = "0" + profileDetails.value.telephone;
      }
      if (e.target.value.length == 6) {
        profileDetails.value.telephone =
          (profileDetails.value.telephone as string).substr(0, 5) +
          " " +
          (profileDetails.value.telephone as string).substr(5);
      }
    };
    const profileDetails = ref<ProfileDetails>({
      firstName: user.value.firstName,
      lastName: user.value.lastName,
      linkedInProfileUrl: user.value.linkedInProfileUrl,
      jobTitle: user.value.jobTitle,
      telephone: user.value.telephone,
      introduction: user.value.introduction,
      profileImage: user.value.profileImage,
    });
    const handleImageUpload = (event) => {
      file = event.target.files[0];
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        tempImage.value = reader.result as string;
        newImageAdded.value = true;
      };
    };
    const saveChanges1 = async () => {
      loading.value = true;
      try {
        let fd = new FormData();
        if (file) fd.append("profileImage", file, file.name);
        fd.append("firstName", profileDetails.value.firstName);
        fd.append("lastName", profileDetails.value.lastName);
        fd.append(
          "linkedInProfileUrl",
          profileDetails.value.linkedInProfileUrl
        );
        fd.append("jobTitle", profileDetails.value.jobTitle);
        fd.append("telephone", profileDetails.value.telephone);
        fd.append("introduction", profileDetails.value.introduction);
        const response = await store.dispatch(Actions.UPDATE_PROFILE, fd);
        if (response !== true) throw new Error();
        store.dispatch(Actions.AUTH_USER);
        loading.value = false;
        store.commit("setAlert", {
          message: "Profile Updated",
          subMessage: "Profile has been updated successfully",
          variant: "primary",
          duration: 4000,
          show: true,
        });
      } catch (err) {
        loading.value = false;
        const error = store.getters.getErrors;
        store.commit("setAlert", {
          message: "Error",
          subMessage: error,
          variant: "danger",
          duration: 4000,
          show: true,
        });
      }
    };
    const changePasswordSubmit = async (values) => {
      loading2.value = true;
      try {
        const response = await store.dispatch(Actions.CHANGE_PASSWORD, values);
        if (response !== true) throw new Error();
        oldPasswordRef.value.reset();
        newPasswordRef.value.reset();
        passwordConfirmationRef.value.reset();
        loading2.value = false;
        store.commit("setAlert", {
          message: "Password Updated",
          subMessage: "Password has been updated successfully",
          variant: "primary",
          duration: 4000,
          show: true,
        });
      } catch (err) {
        loading2.value = false;
        const error = store.getters.getErrors
        store.commit("setAlert", {
          message: error,
          subMessage: "",
          variant: "danger",
          duration: 4000,
          show: true,
        });
      }
    };

    const saveChanges2 = () => {
      if (submitButton2.value) {
        // Activate indicator
        submitButton2.value.setAttribute("data-kt-indicator", "on");

        setTimeout(() => {
          submitButton2.value?.removeAttribute("data-kt-indicator");
        }, 2000);
      }
    };

    const saveChanges3 = () => {
      if (submitButton3.value) {
        // Activate indicator
        submitButton3.value.setAttribute("data-kt-indicator", "on");

        setTimeout(() => {
          submitButton3.value?.removeAttribute("data-kt-indicator");
        }, 2000);
      }
    };

    const saveChanges4 = () => {
      if (submitButton4.value) {
        // Activate indicator
        submitButton4.value.setAttribute("data-kt-indicator", "on");

        setTimeout(() => {
          submitButton4.value?.removeAttribute("data-kt-indicator");
        }, 2000);
      }
    };

    const updateEmail = () => {
      if (updateEmailButton.value) {
        // Activate indicator
        updateEmailButton.value.setAttribute("data-kt-indicator", "on");

        setTimeout(() => {
          updateEmailButton.value?.removeAttribute("data-kt-indicator");

          emailFormDisplay.value = false;
        }, 2000);
      }
    };

    const updatePassword = () => {
      if (updatePasswordButton.value) {
        // Activate indicator
        updatePasswordButton.value.setAttribute("data-kt-indicator", "on");

        setTimeout(() => {
          updatePasswordButton.value?.removeAttribute("data-kt-indicator");

          store.commit("setAlert", {
            message: "Sucess",
            subMessage: "Password is successfully changed!",
            variant: "primary",
            duration: 4000,
            show: true,
          });
          passwordFormDisplay.value = false;
        }, 2000);
      }
    };

    const removeImage = () => {
      // profileDetails.value.avatar = "media/avatars/blank.png";
    };

    onMounted(() => {
      setCurrentPageBreadcrumbs("Settings", ["Account"]);
    });

    return {
      formatTelephone,
      limitInput,
      loading,
      loading2,
      profilePictureRef,
      tempImage,
      newImageAdded,
      passwordConfirmationRef,
      oldPasswordRef,
      newPasswordRef,
      changePasswordSubmit,
      user,
      submitButton1,
      submitButton2,
      submitButton3,
      submitButton4,
      submitButton5,
      saveChanges1,
      saveChanges2,
      saveChanges3,
      saveChanges4,
      profileDetails,
      emailFormDisplay,
      passwordFormDisplay,
      removeImage,
      profileDetailsValidator,
      changeEmail,
      changePassword,
      updateEmailButton,
      updatePasswordButton,
      updateEmail,
      updatePassword,
      handleImageUpload,
    };
  },
});
